/* eslint-disable react-hooks/exhaustive-deps */
import { ElectricityPackagesService } from "components/ElectricityPackages/ElectricityPackages.service";
import { ELECTRICITY_PACKAGE_METER_TYPES, ElectricityPackageMeterType, ElectricityPackageType, IElectricityPackage } from "components/ElectricityPackages/models";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { INDIVIDUAL_PACKAGE_VALUE, UpdateElectricityAgreementPackageModalForm } from "../../models";
import DatePicker from "react-date-picker";
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/calendar.svg';

interface UpdateElectricityAgreementPackageFormProps {
    form: UpdateElectricityAgreementPackageModalForm;
    setForm: (form: UpdateElectricityAgreementPackageModalForm) => void;
    activePackage: IElectricityPackage;
    agreementStartsInFuture: boolean;
    earliestPossibleStartDate: Date;
    endDate?: string;
    hasProductionPackage: boolean;
}

export default function UpdateElectricityAgreementPackageForm(
    { form, setForm, activePackage, agreementStartsInFuture, earliestPossibleStartDate, endDate, hasProductionPackage} : UpdateElectricityAgreementPackageFormProps
) {
    const [consumptionPackages, setConsumptionPackages] = useState<IElectricityPackage[]>([]);
    const [productionPackages, setProductionPackages] = useState<IElectricityPackage[]>([]);

    useEffect(() => {
        getPackages();
    }, []);

    const getPackages = () => {
        ElectricityPackagesService.getElectricityPackages({
            page: 0,
            size: 999
        }).then(res => {
            let packages = res.content
            .filter(pckg => pckg.jointInvoicePackage === form.isJointInvoicePossible)
            .filter((pckg: IElectricityPackage) => pckg.type === ElectricityPackageType.CONSUMPTION);

            const matchingPackage = packages.find((pckg) => pckg.id === activePackage.id);

            setConsumptionPackages(matchingPackage ? packages : [...packages, form.consumptionPackage]);
            setProductionPackages(res.content.filter(pckg => pckg.type === ElectricityPackageType.PRODUCTION));
        });
    }

    const packageOptions = consumptionPackages
        .map(p => ({ value: p.id, label: p.nameEt }));

    packageOptions.push({ value: INDIVIDUAL_PACKAGE_VALUE, label: 'Individuaalne'});

    const setPackageValue = (option?: any) => {
        const consumptionPackage = consumptionPackages.find(p => p.id === option?.value);
        const productionPackage = productionPackages.find(p => p.meterType === ElectricityPackageMeterType.QUARTER_HOUR);

        setForm({
            ...form,
            consumptionPackage: {
                id: option?.value === INDIVIDUAL_PACKAGE_VALUE ? INDIVIDUAL_PACKAGE_VALUE : consumptionPackage?.id,
                termsAndConditionsId: consumptionPackage?.terms?.id,
                basePriceCentsKwh: consumptionPackage?.basePriceCentsKwh,
                basePriceTextEt: consumptionPackage?.basePriceTextEt ?? '',
                basePriceTextEn: consumptionPackage?.basePriceTextEn ?? '',
                contractTitle: consumptionPackage?.contractTitle ?? '',
                pdfFooterDisclaimer: (form.isCompany ? consumptionPackage?.pdfFooterDisclaimerCompany : consumptionPackage?.pdfFooterDisclaimerPerson) ?? '',
                monthlyFeeEuros: consumptionPackage?.monthlyFeeEuros,
                earlyTerminationFeeType: consumptionPackage?.earlyTerminationFeeType,
                earlyTerminationFee: consumptionPackage?.earlyTerminationFee,
                marketPricePackage: !!consumptionPackage?.marketPricePackage,
                pdfProductDescriptionOnInvoice: consumptionPackage?.pdfProductDescriptionOnInvoice,
                externalProductDescriptionOnInvoice: consumptionPackage?.externalProductDescriptionOnInvoice,
                jointInvoicePackage: !!consumptionPackage?.jointInvoicePackage,
                nameEt: consumptionPackage?.nameEt,
                nameEn: consumptionPackage?.nameEn,
                dynamicPackage: !!consumptionPackage?.dynamicPackage,
                greenEnergy: !!consumptionPackage?.greenEnergy,
                baseFixationType: consumptionPackage?.baseFixationType,
                baseConsumptionProportion: consumptionPackage?.baseConsumptionProportion,
                twoTariffPackage: !!consumptionPackage?.twoTariffPackage,
                dayTariffCentsKwh: consumptionPackage?.dayTariffCentsKwh,
                nightTariffCentsKwh: consumptionPackage?.nightTariffCentsKwh,
                meterType: option?.value === INDIVIDUAL_PACKAGE_VALUE ? ElectricityPackageMeterType.QUARTER_HOUR : consumptionPackage?.meterType
            },
            productionPackageId: hasProductionPackage ? productionPackage?.id : undefined,
            estimatedConsumptionVolumeMwh: undefined,
            estimatedConsumptionDayVolumeMwh: undefined,
            estimatedConsumptionNightVolumeMwh: undefined
        })
    }  

    const currentPackageOption = packageOptions.find(p => p.value === form.consumptionPackage?.id);
    const currentMeterType = ELECTRICITY_PACKAGE_METER_TYPES.find(p => p.value === form.consumptionPackage?.meterType);

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-6">
                    <Form.Label>Pakett*</Form.Label>
                    <Select
                        required
                        options={packageOptions}
                        value={currentPackageOption}
                        onChange={setPackageValue}
                        placeholder='Vali elektripakett'
                        className={'w-100 form-control form-select' + (!form.consumptionPackage?.id && form.validated ? ' is-invalid' : '')}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
                { currentPackageOption?.value === INDIVIDUAL_PACKAGE_VALUE ? (
                        <div className="col-12 col-md-6">
                            <Form.Label>Arvesti tüüp*</Form.Label>
                            <Select
                                required
                                options={ELECTRICITY_PACKAGE_METER_TYPES}
                                value={currentMeterType ?? null}
                                placeholder='Vali arvesti tüüp'
                                onChange={(e: any) => setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        meterType: e?.value ?? null
                                    }
                                })}
                                className={'w-100 form-control form-select' + (!form.consumptionPackage?.meterType && form.validated ? ' is-invalid' : '')}
                            />
                            <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback> 
                        </div>
                    ) : null
                }
            </div>
            { currentPackageOption?.value === INDIVIDUAL_PACKAGE_VALUE ?
                (
                    <div className="row mt-3">
                        <div className="col-12 col-md-6">
                            <Form.Label>Paketi eestikeelne nimetus*</Form.Label>
                            <Form.Control
                                required
                                value={form.consumptionPackage?.nameEt}
                                onChange={(e: any) => setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        nameEt: e.target.value
                                    }
                                })}
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <Form.Label>Paketi inglisekeelne nimetus</Form.Label>
                            <Form.Control
                                value={form.consumptionPackage?.nameEn}
                                onChange={(e: any) => setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        nameEn: e.target.value
                                    }
                                })}
                            />
                        </div>
                    </div>
                ) : null
            }
            { !agreementStartsInFuture && (
                    <div className="row mt-3">
                        <div className="col-12 col-md-6">
                            <Form.Label htmlFor="contract-start">Paketi algus*</Form.Label>
                                <DatePicker
                                    className={'d-block' + (form.startDate === undefined && form.validated ? ' invalid is-invalid' : '')}
                                    value={new Date(form.startDate)}
                                    locale='et'
                                    clearIcon={null}
                                    calendarIcon={<CalendarIcon />}
                                    format='dd.MM.yyyy'
                                    minDate={earliestPossibleStartDate}
                                    maxDate={endDate ? new Date(endDate) : undefined}
                                    onChange={(event: any) => {
                                        if(!event){
                                            return;
                                        }
                                        setForm({
                                            ...form, 
                                            startDate: new Date(event).toString(),
                                        })
                                    }}
                                    required
                                />
                                <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                            </div>
                    </div>
            )}
            <div className="row mt-3">
                <div className="col-12 col-md-6">
                    <Form.Check
                        className='form-check-input-no-label'
                        id='market-price-check'
                        label='Börsipakett'
                        checked={form.consumptionPackage?.marketPricePackage}
                        disabled={currentPackageOption?.value !== INDIVIDUAL_PACKAGE_VALUE || form.consumptionPackage?.dynamicPackage || form.consumptionPackage?.twoTariffPackage}
                        onChange={(e: any) => {
                            if(e.target.checked){
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        marketPricePackage: true,
                                        basePriceCentsKwh: !form.consumptionPackage?.marketPricePackage ? undefined : form.consumptionPackage.basePriceCentsKwh,
                                        basePriceTextEt: !form.consumptionPackage?.marketPricePackage ? !form.consumptionPackage?.basePriceTextEt ? 'Börsihind + marginaal' : form.consumptionPackage.basePriceTextEt : '',
                                        basePriceTextEn: !form.consumptionPackage?.marketPricePackage ? !form.consumptionPackage?.basePriceTextEn ? 'Market price + margin' : form.consumptionPackage.basePriceTextEn : ''
                                    }
                                })
                            }else{
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        marketPricePackage: false
                                    }
                                })
                            }
                        }
                        }
                        type='checkbox'
                    />
                    <Form.Check
                        className='form-check-input-no-label'
                        id='dynamic-package-check'
                        label='Dünaamiline pakett'
                        checked={form.consumptionPackage?.dynamicPackage}
                        disabled={true}
                        onChange={(e: any) => {
                            if(e.target.checked){
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        dynamicPackage: true,
                                        marketPricePackage: false,
                                        basePriceCentsKwh: !form.consumptionPackage?.dynamicPackage ? undefined : form.consumptionPackage.basePriceCentsKwh,
                                    }
                                })
                            }else{
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        dynamicPackage: false,
                                        basePriceCentsKwh: undefined
                                    }
                                })
                            }
                        }}
                        type='checkbox'
                    />
                    <Form.Check
                        className='form-check-input-no-label'
                        id='two-tariff-package-check'
                        label='Kahetariifiline pakett'
                        checked={form.consumptionPackage?.twoTariffPackage}
                        disabled={currentPackageOption?.value !== INDIVIDUAL_PACKAGE_VALUE || form.consumptionPackage?.marketPricePackage || form.consumptionPackage?.dynamicPackage}
                        onChange={(e: any) => {
                            if(e.target.checked){
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        twoTariffPackage: true
                                    }
                                })
                            }else{
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        twoTariffPackage: false,
                                        dayTariffCentsKwh: undefined,
                                        nightTariffCentsKwh: undefined
                                    }
                                })
                            }
                        }}
                        type='checkbox'
                    />
                    <Form.Check
                        className='form-check-input-no-label'
                        id='green-energy-package-check'
                        label='Roheteenus'
                        checked={form.consumptionPackage?.greenEnergy}
                        disabled={currentPackageOption?.value !== INDIVIDUAL_PACKAGE_VALUE}
                        onChange={(e: any) => setForm({
                            ...form,
                            consumptionPackage: {
                                ...form.consumptionPackage,
                                greenEnergy: e.target.checked,
                            }
                        })}
                        type='checkbox'
                    />
                    <Form.Check
                        className='form-check-input-no-label'
                        id='joint-invoice-check'
                        label='Ühisarve'
                        checked={form.consumptionPackage?.jointInvoicePackage}
                        disabled={currentPackageOption?.value !== INDIVIDUAL_PACKAGE_VALUE}
                        onChange={(e: any) => setForm({
                            ...form,
                            consumptionPackage: {
                                ...form.consumptionPackage,
                                jointInvoicePackage: !form.consumptionPackage?.jointInvoicePackage,
                            }
                        })}
                        type='checkbox'
                    />
                </div>
            </div>
        </>
    );
}